import "./App.css";
import React, { useState } from "react";
import { setPersistence, browserLocalPersistence } from "firebase/auth";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebaseConfig";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
  getDoc,
  doc,
  setDoc,
  getDocs, deleteDoc,
  query, where

} from "firebase/firestore";
//import { db } from "./firebaseConfig";


import {
  OAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import Loader from "./Loader";
export default function SignUp() {

  const db = getFirestore();
  const [authing, setAuthing] = useState(false);
  const [authingOne, setAuthingOne] = useState(false);
  const [authingTwo, setAuthingTwo] = useState(false);
  const [authingThree, setAuthingThree] = useState(false);
  var data = {};
  data = {
    token: "",
    email: "",
    name: "",
    refreshToken: "",
    localId: "",
    photoURL: "",
    phoneNumber: "",
  };
  const [loading, setLoading] = useState(false);
  const [firstname, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const handleAppleSignIn = async () => {
    await setPersistence(auth, browserLocalPersistence);
    const provider = new OAuthProvider("apple.com");
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      data = {
        token: user.accessToken,
        email: user.email,
        name: user.displayName,
        refreshToken: user.refreshToken,
        localId: user.reloadUserInfo.localId,
        photoURL: user.photoURL,
        phoneNumber: user.phoneNumber,
      };
      global.updateRefCodeMode(true);
      setLoading(false);
      console.log("User signed in successfully:", user);
    } catch (error) {
      console.error("Error signing in with Apple:", error);
    }
  };
  const getUserFromGauth = async (docId) => {
    
    const docRef = doc(db, "tempauth", docId);
    localStorage.removeItem("GAUTH");
    try {
      // Fetch the document data
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        var user = docSnap.data();
        if (user.token && user.token != "") {
          setUser(user); // User successfully authenticated
          data = {
            token: user.token,
            email: user.email,
            name: user.name,
            refreshToken: user.refreshToken,
            localId: user.localId,
            photoURL: user.photoURL,
            phoneNumber: user.phoneNumber,
          };
          data = JSON.stringify(data);
          localStorage.setItem("USERDATA", data);
          global.updateRefCodeMode(true);
          setLoading(false);
          createOrUpdateUserSession(data);
        } else {
          console.log("No Data Found");
        }
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };


  const createOrUpdateUserSession = async (userdata) => {
      const tg = window.Telegram.WebApp;
      const user = tg.initDataUnsafe?.user;
      if (!user || !user.id) {
        return false;
      }
      const tgUserid = parseInt(user.id);
    
  
      try {
        // Query existing session
        const q = query(
          collection(db, "telegram_sessions"),
          where("tgUserid", "==", parseInt(tgUserid))
        );
        
        const querySnapshot = await getDocs(q);
      
        for (const docSnapshot of querySnapshot.docs) {
          await deleteDoc(docSnapshot.ref);
        }
    
        
        await addDoc(collection(db, "telegram_sessions"), {
          tgUserid,
          userdata: userdata,
          timestamp: Date.now(), // Store current timestamp
        });
    
        console.log("Session replaced successfully!");
      } catch (error) {
        console.error("Error replacing session:", error);
      }
  
  
    };


  const handleGoogleSignIn = async (e) => {
    setAuthing(true);
    setAuthingOne(true);
    
    const tempauthCollection = collection(db, "tempauth");
    try {
      // Create a new document with the current timestamp
      const docRef = await addDoc(tempauthCollection, {
        timestamp: serverTimestamp(),
      });
      localStorage.setItem("GAUTH", docRef.id);
      setAuthingTwo(true);
      setTimeout(function () {
        setAuthingThree(true);
      }, 10000);
      if (window.Telegram.WebApp) {
        window.Telegram.WebApp.openLink(
          "https://telegram.emorya.com/#/auth/?t=" + docRef.id
        );
      } else {
        window.open(
          "https://telegram.emorya.com/#/auth/?t=" +
            docRef.id,
          "_blank"
        );
      }
      console.log("Document written with ID:", docRef.id);
      return docRef.id;
    } catch (error) {
      console.error("Error adding document:", error);
    }
  };
  // const handleGoogleSignInOne = async () => {
  //   setLoading(true);
  //   const provider = new GoogleAuthProvider();
  //   try {
  //     await setPersistence(auth, browserLocalPersistence);
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;
  //     setUser(user); // User successfully authenticated
  //     data = {
  //       token: user.accessToken,
  //       email: user.email,
  //       name: user.displayName,
  //       refreshToken: user.refreshToken,
  //       localId: user.reloadUserInfo.localId,
  //       photoURL: user.photoURL,
  //       phoneNumber: user.phoneNumber,
  //     };
  //     data = JSON.stringify(data);
  //     localStorage.setItem("USERDATA", data);
  //   global.updateRefCodeMode(true);
  //   setLoading(false);
  //   } catch (error) {
  //     console.error("Error signing up with Google:", error);
  //   }
  // };
  const handleSignUp = async () => {
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      data = {
        token: userCredential.user.accessToken,
        email: userCredential.user.email,
        name: firstname + " " + lastName,
        localId: userCredential.user.uid,
      };
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        firstName: firstname,
        lastName: lastName,
        createdAt: new Date().toISOString(),
        id: user.uid,
      });
      data = JSON.stringify(data);
      localStorage.setItem("USERDATA", data);
      global.updateRefCodeMode(true);
      setLoading(false);
      createOrUpdateUserSession(data);
    } catch (error) {
      setLoading(false);
      console.error("Error signing up with email and password:", error);
      setError(error.message);
    }
  };
  return (
    <>
      <div
        className="section"
        style={{
          justifyContent: "center",
        }}
      >
        <Loader loading={loading}></Loader>
        <img
          alt=""
          src={require("./assets/logo.png")}
          style={{
            width: "70%",
          }}
        ></img>
        <br />
        <br />
        <div
          className="row"
          style={{
            width: "90%",
          }}
        >
          {authing ? (
            <>
              <div
                className="section"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  background: "rgba(0,0,0,0.8)",
                  zIndex: 200,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {authingOne ? (
                  <>
                    <div
                      style={{
                        padding: 20,
                        textAlign: "left",
                      }}
                    >
                      Please wait..
                      <br />
                      <br />
                    </div>
                  </>
                ) : null}
                {authingTwo ? (
                  <>
                    <div
                      style={{
                        padding: 20,
                      }}
                    >
                      You will be redircted to your browser for authntication.
                      Once authorized, come back to this window.
                      <br />
                      <br />
                    </div>
                  </>
                ) : null}
                {authingThree ? (
                  <>
                    <div
                      style={{
                        padding: 20,
                      }}
                    >
                      Click on the button below when you authorized on your
                      browser.
                      <br />
                      <br />
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          if (localStorage.getItem("GAUTH")) {
                            getUserFromGauth(localStorage.getItem("GAUTH"));
                          }
                        }}
                      >
                        Proceed.
                      </button>
                    </div>
                  </>
                ) : null}
              </div>
            </>
          ) : null}
          <div
            className="col-sm-12"
            style={{
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <div
              className="subHeading"
              style={{
                textAlign: "center",
              }}
            >
              Sign Up With New Account
            </div>
            <br />
            {error && (
              <p style={{ color: "red" }}>
                <div className="badge bg-danger">{error}</div>
              </p>
            )}
            <input
              type="text"
              className="input"
              placeholder="First Name"
              onChange={(e) => setFirstName(e.target.value)}
              value={firstname}
            />
            <br />
            <br />
            <input
              type="text"
              className="input"
              placeholder="Last Name"
              onChange={(e) => setLastName(e.target.value)}
              value={lastName}
            />
            <br />
            <br />
            <input
              type="text"
              className="input"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <br />
            <input
              type="password"
              className="input"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <p style={{ color: "red" }}>
                <div className="badge bg-danger"></div>
              </p>
            )}
            <br />
            <br />
            <button
              className="btn btn-sm btn-success gradColor"
              onClick={() => {
                //                global.signInNow();
                handleSignUp();
              }}
            >
              Sign Me Up
            </button>
            <br />
            <br />
          </div>
        </div>
        <div className="bottomSection">
          <div className="row">
            <div className="col-12">
              <button
                className="btn btn-sm btn-light"
                onClick={() => {
                  handleGoogleSignIn();
                }}
              >
                <i
                  className="fab fa-google"
                  style={{
                    fontSize: 12,
                    marginTop: -2,
                  }}
                ></i>
                &nbsp;&nbsp;Gmail
              </button>
            </div>
            <div className="col-sm-12">
              <br />
              <div
                onClick={() => {
                  global.updateSignUpMode(false);
                }}
                className="subHeading"
                style={{
                  fontSize: 11,
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Already Have An Account? Login Now&nbsp;&nbsp;
                <i className="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
